// GroupChat.js -- Yellow dot notification works, but upon refresh.
// the group name can be updated by any member -reflected for everyone
// has a members counter next to the group name
// messages can be edited and deleted by the creator. 
// users can leave a group, and the group will be removed from list
// everything works in the (...) menu




import React, { useEffect, useRef, useState, useContext } from 'react';
import { useUser } from '../context/UserContext';
import { collection, doc, getDoc, getDocs, setDoc, addDoc, updateDoc, deleteDoc, arrayRemove, onSnapshot, query, where, orderBy, serverTimestamp } from 'firebase/firestore';
import { db, functions } from '../firebaseConfig';
import { getAuth } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import { useLocation } from 'react-router-dom';
import './GroupChat.css';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { Keyboard } from '@capacitor/keyboard';
import { Capacitor } from '@capacitor/core';
import { saveToGallery, formatSaveMessage } from '../utils/saveToGallery';
import ZoomableImage from './ZoomableImage';
import { markConversationAsViewed } from '../firebase/messagingUtils';
import { getStatesWithHomeFirst } from '../utils/states';



  
  const storage = getStorage(undefined, 'blue-wire-e382b.firebasestorage.app');

  

  const GroupChat = ({ groupId, onBack, refreshGroupList }) => {
  // 🔹 Must call hooks at top level
  const location = useLocation();
  const auth = getAuth();

	

  // 🔹 Fallback logic for current user
  const { currentUser } = useUser();
 const routeUser = location.state?.currentUser;
const activeUser = currentUser || routeUser || auth.currentUser;

  const [messages, setMessages] = useState([]);
  const [groupName, setGroupName] = useState('');
  const [participants, setParticipants] = useState([]);
  const [messageInput, setMessageInput] = useState('');
  const chatEndRef = useRef(null);
  const [groupUsers, setGroupUsers] = useState([]);
  const [showParticipants, setShowParticipants] = useState(false);
  const [editedGroupName, setEditedGroupName] = useState('');
  const [editingMsgId, setEditingMsgId] = useState(null);
  const [editedMsg, setEditedMsg] = useState('');
  const [isEditingGroupName, setIsEditingGroupName] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const participantCount = participants.length;
  const [showAddModal, setShowAddModal] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [groupAgencyFilter, setGroupAgencyFilter] = useState('');
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [selectAllFiltered, setSelectAllFiltered] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [members, setMembers] = useState([]);
  const [conversationDeleting, setConversationDeleting] = useState(false);
  const [searchState, setSearchState] = useState(activeUser?.state || '');
  const [searchStateTouched, setSearchStateTouched] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [searchFields, setSearchFields] = useState({});
  const [searchAttempted, setSearchAttempted] = useState(false);
  const [localPreviews, setLocalPreviews] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [attachmentMenuOpen, setAttachmentMenuOpen] = useState(false);
  const [isSendingMessage, setIsSendingMessage] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const messagesContainerRef = useRef(null);
  const prevMessagesRef = useRef([]);
  const [isAtBottom, setIsAtBottom] = useState(true);

  const [dropdownOptions, setDropdownOptions] = useState({
  agencies: [],
  assignments: [],
  ranks: [],
});
  const [agencyList, setAgencyList] = useState([]);
  const [assignmentList, setAssignmentList] = useState([]);
  const [rankList, setRankList] = useState([]);
  const [matchedUsers, setMatchedUsers] = useState([]);


	const menuRef = useRef(null);
	const participantsRef = useRef(null);
	const fileInputRef = useRef(null);
	const cameraInputRef = useRef(null);
	const sidebarRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setShowOptions(false);
    }

    if (participantsRef.current && !participantsRef.current.contains(e.target)) {
      setShowParticipants(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);


	 	// ✅ Then guard the render *after* hooks*
if (!activeUser) {
  console.warn('⏳ Waiting for user to load...');
}


	const users = allUsers.filter(u => !groupUsers.some(g => g.id === u.id));
	


	const menuBtnStyle = {
  display: 'block',
  background: 'none',
  border: 'none',
  textAlign: 'left',
  padding: '6px 0',
  width: '100%',
  cursor: 'pointer',
  fontSize: '14px'
};


	
	


const MAX_FILE_SIZE_MB = 10;
const MAX_GIF_SIZE_MB = 15; // allow larger GIFs
const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
const MAX_GIF_SIZE = MAX_GIF_SIZE_MB * 1024 * 1024;

const handleFileUpload = async (e) => {
  const files = Array.from(e.target.files || []);
  if (!files.length) return;

  const processedFiles = [];

  for (let file of files) {
    const isGif = (file.type || '').toLowerCase() === 'image/gif' || /\.gif$/i.test(file.name || '');
    if (isGif) {
      if (file.size > MAX_GIF_SIZE) {
        alert(`${file.name} exceeds ${MAX_GIF_SIZE_MB}MB and was skipped.`);
        continue;
      }
      processedFiles.push(file);
      continue;
    }

    if (file.size > MAX_FILE_SIZE) {
      alert(`${file.name} exceeds ${MAX_FILE_SIZE_MB}MB and was skipped.`);
      continue;
    }
    processedFiles.push(file);
  }

  setSelectedFiles(prev => [...prev, ...processedFiles]);
  setAttachmentMenuOpen(false);
  e.target.value = '';
};




	const handleRemoveFile = (index) => {
  setSelectedFiles(prev => prev.filter((_, i) => i !== index));
};

	


	const handleLeaveGroup = async () => {
  const confirmed = window.confirm("Are you sure you want to leave this group?");
  if (!confirmed) return;

  const userId = activeUser?.uid;
  if (!userId) return;

  try {
    const groupRef = doc(db, 'conversations', groupId);
    const groupSnap = await getDoc(groupRef);
    const data = groupSnap.exists() ? groupSnap.data() : {};
    const groupMembers = data.members || [];

    // Check if this is the last member
    if (groupMembers.length === 1 && groupMembers[0] === userId) {
      const deleteConversation = httpsCallable(functions, 'deleteConversation');
      await deleteConversation({ chatId: groupId });
      alert("Group deleted.");
    } else {
      // Just leave the group
      await updateDoc(groupRef, {
        members: arrayRemove(userId),
      });
    }

    onBack();
    refreshGroupList();
  } catch (err) {
    console.error("Failed to leave or delete group:", err);
    alert("Error processing your request.");
  }
};



	const handleDeleteGroup = async () => {
  if (!window.confirm("Are you sure you want to delete this group and all its messages?")) return;

  try {
    const deleteConversation = httpsCallable(functions, 'deleteConversation');
    await deleteConversation({ chatId: groupId });

    alert("Group deleted.");
    onBack(); // Navigate back to group list
  } catch (err) {
    console.error("Failed to delete group:", err);
    alert("Error deleting group.");
  }
};



	const handleGroupNameSave = async () => {
  if (!editedGroupName.trim()) return;

  try {
    const groupRef = doc(db, 'conversations', groupId);
    await updateDoc(groupRef, { name: editedGroupName.trim() });
    setGroupName(editedGroupName.trim());

    // 🔄 Refresh group list in parent if provided
    if (refreshGroupList) {
      refreshGroupList();
    }
  } catch (err) {
    console.error('Failed to update group name:', err);
  } finally {
    setIsEditingGroupName(false);
  }
};



	const handleSaveEdit = async (msgId) => {
  const trimmed = editedMsg.trim();
  if (!trimmed) {
    alert('Message cannot be blank.');
    return;
  }

  try {
    const msgRef = doc(db, 'conversations', groupId, 'messages', msgId);
    const snapshot = await getDoc(msgRef);
    const existingContent = snapshot.exists() ? snapshot.data().content : '';
    const editedContent = editedMsg;

    if (existingContent !== editedContent) {
      await updateDoc(msgRef, {
        content: editedContent,
        editedAt: serverTimestamp(), // ✅ Add this
      });
    }

    setEditingMsgId(null);
    setEditedMsg('');
  } catch (err) {
    console.error('Failed to save edited message:', err);
  }
};



	const runUserSearch = async () => {
  if (!searchState && Object.values(searchFields).every((v) => !v.trim())) {
    alert("Please provide at least one filter.");
    return;
  }

  setSearching(true);
  try {
    const usersRef = collection(db, 'users');
    let q = query(usersRef);

    if (searchState) {
      q = query(q, where('state', '==', searchState));
    }

    Object.entries(searchFields).forEach(([field, value]) => {
      if (value && value.trim() !== '') {
        const trimmed = value.trim();
        if (field === 'lastName') {
          q = query(q, where('lastNameLower', '==', trimmed.toLowerCase()));
        } else {
          q = query(q, where(field, '==', trimmed));
        }
      }
    });

    const snapshot = await getDocs(q);
    const matched = [];
    snapshot.forEach((doc) => {
      matched.push({ id: doc.id, ...doc.data() });
    });

    setMatchedUsers(matched); // <-- NEW: store unfiltered results
   const filtered = matched.filter((user) => !participants.includes(user.id));
    setSearchResults(filtered);
  } catch (err) {
    console.error('Search error:', err);
  } finally {
    setSearching(false);
  }
};

	


	const handleAddSearchField = (field) => {
  if (field && !searchFields[field]) {
    setSearchFields(prev => ({ ...prev, [field]: '' }));
  }
};



const handleRemoveSearchField = (field) => {
  const updated = { ...searchFields };
  delete updated[field];
  setSearchFields(updated);
};



const handleRunSearch = async () => {
  // ✅ Check 1: Prevent no filters at all
  const hasValidFilters = Object.values(searchFields).some(
    (val) => val?.trim?.() !== ''
  );

  if (!searchState && !hasValidFilters) {
    alert('Please select at least one filter before searching.');
    return;
  }

  // ✅ Check 2: Prevent only state with no filters
  const onlyStateSet =
    searchState &&
    !searchFields.lastName &&
    !searchFields.agency &&
    !searchFields.assignment &&
    !searchFields.rank;

  if (onlyStateSet) {
    alert('Please add at least one additional filter besides state.');
    return;
  }

  setSearchAttempted(true);

  try {
    const userCollection = collection(db, 'users');
    let q = userCollection;

    if (searchState) {
      q = query(q, where('state', '==', searchState));
    }

    Object.entries(searchFields).forEach(([field, value]) => {
      if (value && value.trim() !== '') {
        if (field === 'lastName') {
          q = query(q, where('lastNameLower', '==', value.trim().toLowerCase()));
        } else {
          q = query(q, where(field, '==', value.trim()));
        }
      }
    });

    const snap = await getDocs(q);
    const results = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    // Filter out users already in the group
    const filtered = results.filter(user => !participants.includes(user.id));
    setSearchResults(filtered);
  } catch (err) {
    console.error('Search failed:', err);
    alert('Error running search.');
  }
};




	useEffect(() => {
  if (!Capacitor.isNativePlatform()) return;

  let willShow, willHide, didShow, didHide;

  (async () => {
    willShow = await Keyboard.addListener('keyboardWillShow', () => {
      console.log('📱 Keyboard WILL show');
      document.body.classList.add('keyboard-open');
      console.log('Body classes:', document.body.className);
    });
    willHide = await Keyboard.addListener('keyboardWillHide', () => {
      console.log('📱 Keyboard WILL hide');
      document.body.classList.remove('keyboard-open');
      console.log('Body classes:', document.body.className);
    });

    didShow = await Keyboard.addListener('keyboardDidShow', () => {
      console.log('📱 Keyboard DID show');
      document.body.classList.add('keyboard-open');
      console.log('Body classes:', document.body.className);
    });
    didHide = await Keyboard.addListener('keyboardDidHide', () => {
      console.log('📱 Keyboard DID hide');
      document.body.classList.remove('keyboard-open');
      console.log('Body classes:', document.body.className);
    });
  })();

  return () => {
    willShow?.remove?.();
    willHide?.remove?.();
    didShow?.remove?.();
    didHide?.remove?.();
  };
}, []);



useEffect(() => {
  if (!showAddModal || !searchState) return;

  const fetchDropdownOptions = async () => {
    const q = query(collection(db, 'users'), where('state', '==', searchState));
    const snap = await getDocs(q);
    const users = snap.docs.map(doc => doc.data());

    setAgencyList([...new Set(users.map(u => u.agency).filter(Boolean))]);
    setAssignmentList([...new Set(users.map(u => u.assignment).filter(Boolean))]);
    setRankList([...new Set(users.map(u => u.rank).filter(Boolean))]);
  };

  fetchDropdownOptions();
}, [showAddModal, searchState]);

  useEffect(() => {
    if (!showAddModal) return;
    if (!searchStateTouched && activeUser?.state) {
      setSearchState(activeUser.state);
    }
  }, [showAddModal, activeUser?.state, searchStateTouched]);




	const handleDeleteMessage = async (msgId) => {
  if (!groupId || !msgId) return;

  const confirmed = window.confirm('Delete this message?');
  if (!confirmed) return;

  try {
    await deleteDoc(doc(db, 'conversations', groupId, 'messages', msgId));
  } catch (err) {
    console.error('Failed to delete message:', err);
  }
};
	
   


   const toggleUserSelection = (userId) => {
  setSelectedUserIds(prev =>
    prev.includes(userId)
      ? prev.filter(id => id !== userId)
      : [...prev, userId]
  );
};



const handleAddSelectedUsers = async () => {
  try {
    const groupRef = doc(db, 'conversations', groupId);

    // Fetch latest group data (optional, if not already live)
    const groupSnap = await getDoc(groupRef);
    const currentMembers = groupSnap.data().members || [];

    // Merge new IDs, remove duplicates
    const updatedMembers = Array.from(new Set([...currentMembers, ...selectedUserIds]));

    await updateDoc(groupRef, {
      members: updatedMembers
    });

   const newUsers = searchResults.filter(user => selectedUserIds.includes(user.id)).map(user => ({
  id: user.id,
  name: user.firstInitialLastName || user.fullName || 'Unknown',
  agency: user.agency || 'Unknown Agency'
}));

setGroupUsers(prev => [...prev, ...newUsers.filter(u => !prev.some(p => p.id === u.id))]);


setParticipants(updatedMembers);

    // Show success message with names
    const addedNames = users
      .filter(user => selectedUserIds.includes(user.id))
      .map(user => user.name)
      .join(', ');
    setSuccessMessage(`${addedNames} added to the group`);

    setShowAddModal(false);
    setSelectedUserIds([]);
    refreshGroupList?.(); 
  } catch (err) {
    console.error("Failed to add participants:", err);
  }
};

	

// Disables the scroll function when in the group chat window
useEffect(() => {
  document.body.classList.add('chat-open');
  document.documentElement.classList.add('chat-open');
  return () => {
    document.body.classList.remove('chat-open');
    document.documentElement.classList.remove('chat-open');
  };
}, []);

useEffect(() => {
  const el = messagesContainerRef.current;
  if (!el) return;

  const handleScroll = () => {
    const threshold = 250; // px from bottom
    const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
    setIsAtBottom(distanceFromBottom <= threshold);
  };

  el.addEventListener('scroll', handleScroll);
  return () => el.removeEventListener('scroll', handleScroll);
}, []);

useEffect(() => {
  if (!groupId) return;

  const groupRef = doc(db, 'conversations', groupId);
  const unsub = onSnapshot(groupRef, (snap) => {
    if (!snap.exists()) {
      onBack();
      return;
    }

    const data = snap.data();
    if (data.deleting === true) {
      setConversationDeleting(true);
      onBack(data.deleteRequestedBy !== activeUser?.uid ? { convoDeleted: true } : null);
      return;
    }

    setConversationDeleting(false);
    setMembers(data.members || []);
  });

  return () => unsub();
}, [groupId]);

const isLastMember =
  activeUser &&
  members?.length === 1 &&
  members[0] === activeUser.uid;



  useEffect(() => {
  if (!groupId) return;

  const q = query(
    collection(db, 'conversations', groupId, 'messages'),
    orderBy('createdAt')
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {
    const msgs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setMessages(msgs);
  });

  return () => unsubscribe();
}, [groupId]);



	// ✅ Mark conversation as viewed only when user is *actively viewing* messages
useEffect(() => {
  if (!groupId || !activeUser?.uid || messages.length === 0) return;

const handleFocus = async () => {
  try {
    const viewRef = doc(db, 'conversations', groupId, 'views', activeUser.uid);
    await setDoc(
      viewRef,
      {
        lastViewed: serverTimestamp(),
        userId: activeUser.uid, // ✅ keep this
      },
      { merge: true }
    );
    console.log(`👁️ Marked group ${groupId} as viewed`);

    // 🕒 Delay ensures Firestore commit finishes before list refresh
    setTimeout(() => {
      if (typeof refreshGroupList === 'function') {
        console.log('🔁 Triggering delayed refresh to clear dot');
        refreshGroupList();
      }
    }, 800);
  } catch (err) {
    console.error('Failed to mark group as viewed:', err);
  }
};

  // Run once when opening the chat
  handleFocus();

  // Run again when user scrolls to bottom (actively viewing)
  const container = messagesContainerRef.current;
  if (container) {
    const onScroll = () => {
      const distanceFromBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight;
      if (distanceFromBottom < 200) handleFocus();
    };
    container.addEventListener('scroll', onScroll);
    return () => container.removeEventListener('scroll', onScroll);
  }
}, [groupId, activeUser?.uid, messages.length]);




 useEffect(() => {
  const fetchGroupData = async () => {
    const groupDoc = await getDoc(doc(db, 'conversations', groupId));
    if (groupDoc.exists()) {
      const data = groupDoc.data();
      setGroupName(data.name || 'Unnamed Group');

      const memberIds = data.members || [];
      setParticipants(memberIds);

      const usersCollection = collection(db, 'users');
      const userPromises = memberIds.map(async (id) => {
        try {
          const userDoc = await getDoc(doc(usersCollection, id));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            return {
              id,
              name: userData.firstInitialLastName || 'Unknown',
              agency: userData.agency || 'Unknown Agency'
            };
          } else {
            return { id, name: 'Unknown', agency: 'Unknown Agency' };
          }
        } catch (err) {
          console.error(`Error fetching user ${id}:`, err);
          return { id, name: 'Error', agency: 'Error' };
        }
      });

      const resolvedUsers = await Promise.all(userPromises);
      setGroupUsers(resolvedUsers);
    }
  };

  if (groupId) fetchGroupData();
}, [groupId]);



 const scrollToBottom = (behavior = 'auto') => {
  chatEndRef.current?.scrollIntoView({ behavior });
};


useEffect(() => {
  if (!messages.length) return;

  const prevMessages = prevMessagesRef.current;
  const newMessageAdded =
    prevMessages.length && messages.length > prevMessages.length;

  // On first load
  if (!prevMessages.length) {
    scrollToBottom('auto');
  }

  // On new messages while user is near bottom
  if (newMessageAdded && isAtBottom) {
    scrollToBottom('smooth');
  }

  prevMessagesRef.current = messages;
}, [messages, isAtBottom]);




  const handleSendMessage = async () => {
  if (isSendingMessage) return;
  if (!activeUser?.uid) {
    console.error('activeUser not ready');
    return;
  }

  if (!messageInput.trim() && selectedFiles.length === 0) return;
  if (conversationDeleting) {
    alert('This conversation is being deleted.');
    return;
  }

  try {
    setIsSendingMessage(true);
    const userDocRef = doc(db, 'users', activeUser.uid);
    const userDocSnap = await getDoc(userDocRef);
    const userData = userDocSnap.exists() ? userDocSnap.data() : {};
    const fileUrls = [];

    for (const file of selectedFiles) {
      const sanitizedFileName = encodeURIComponent(file.name.replace(/\s+/g, '_'));
      const filePath = `group_uploads/${groupId}/${Date.now()}_${sanitizedFileName}`;
      const fileRef = ref(storage, filePath);
      await uploadBytes(fileRef, file);
      const url = await getDownloadURL(fileRef);
      fileUrls.push({ url, type: file.type.startsWith('image/') ? 'image' : 'file' });
    }

    // ✅ Combine into ONE message
  const newMsgRef = await addDoc(collection(db, 'conversations', groupId, 'messages'), {
  senderId: activeUser.uid,
  senderName: userData.firstInitialLastName || 'Unknown',
  agency: userData.agency || 'Unknown Agency',
  createdAt: new Date(),
  content: messageInput,
  mediaAttachments: fileUrls,
  readBy: [activeUser.uid],
});

// ✅ Update conversation meta for unread tracking
// ✅ Ensure both fields always update for all senders
const groupRef = doc(db, 'conversations', groupId);
try {
  await setDoc(
    groupRef,
    {
      lastMessageAt: serverTimestamp(),
      lastMessageSender: activeUser.uid,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
  console.log(`🕒 Updated lastMessageAt for group ${groupId}`);
} catch (err) {
  console.error("❌ Failed to update lastMessageAt:", err);
}

    setMessageInput('');
    setSelectedFiles([]);
// reset height to 1 line
const textarea = document.querySelector('.group-message-input-area textarea');
if (textarea) {
  textarea.style.height = 'auto'; 
}
  } catch (err) {
    console.error('Failed to send message or upload files:', err);
  } finally {
    setIsSendingMessage(false);
  }
};




	async function saveHandler() {
  try {
    const result = await saveToGallery(modalImage);
    alert(formatSaveMessage(result));
  } catch (err) {
    console.error('Save failed:', err);
    alert('Error: ' + (err.message || JSON.stringify(err)));
  }
}






  return (
   <div className="group-chat-container">
    <div className="group-header group-header-fixed">
   {/* Back Button on the Left */}
   <button
     className="group-back-button"
     onClick={() => onBack?.()}
     type="button"
   >
     ←
   </button>

  {/* Group Name in Center */}
  <div style={{ flexGrow: 1, textAlign: 'center' }}>
   {isEditingGroupName ? (
  <input
    value={editedGroupName}
    onChange={(e) => setEditedGroupName(e.target.value)}
    onBlur={handleGroupNameSave}
    autoFocus
    className="edit-group-name-input"
    style={{
      fontSize: '18px',
      fontWeight: 'bold',
      textAlign: 'center',
      border: '1px solid #ccc',
      borderRadius: '4px',
      padding: '4px 8px',
      width: '100%',
    }}
  />
) : (
  <h2 className="group-title" style={{ cursor: 'pointer' }}>
  {groupName} {participants.length ? `(${participants.length})` : ''}
</h2>

)}

  </div>

  {/* 3-dot Menu on Right */}
<div style={{ flex: '0 0 auto', position: 'relative' }} ref={menuRef}>
  <button
    className="group-menu-button"
    onClick={() => setShowOptions(!showOptions)}
    style={{
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer',
    }}
  >
    ⋯
  </button>

  {showOptions && (
  <div
    className="group-options-menu"
  >
    <button
      className="group-dropdown-item"
      onClick={() => {
        setShowOptions(false);
        setTimeout(() => {
          setIsEditingGroupName(true);
          setEditedGroupName(groupName);
        }, 100);
      }}
    >
      ✏️ Edit Group Name
    </button>

    <div style={{ position: 'relative' }}>
      <button
        className="group-dropdown-item"
        onClick={() => setShowParticipants(prev => !prev)}
      >
        👥 View Participants
      </button>

      {showParticipants && (
        <div
          className="participants-sidebar"
          ref={participantsRef}
        >
          {groupUsers.map((user) => (
            <div key={user.id} className="participant-item">
              {user.name}, {user.agency}
            </div>
          ))}
        </div>
      )}
    </div>

    <button
      className="group-dropdown-item"
      onClick={() => {
        setShowAddModal(true);
        setSearchStateTouched(false);
        setShowOptions(false);
      }}
    >
      ➕ Add Participants
    </button>

    {isLastMember ? (
      <button
        className="group-dropdown-item danger"
        onClick={handleDeleteGroup}
      >
        🗑️ Delete Group
      </button>
    ) : (
      <button
        className="group-dropdown-item danger"
        onClick={handleLeaveGroup}
      >
        🚪 Leave Group
      </button>
    )}
  </div>
)}

</div>

</div>



	{Array.isArray(localPreviews) && localPreviews.length > 0 && (
localPreviews.map(preview => (
  <div key={preview.id} style={{ position: 'relative', margin: '6px 0' }}>
    {preview.type === 'image' ? (
      <img
        src={preview.url}
        alt="preview"
        style={{ maxWidth: '150px', maxHeight: '150px' }}
      />
    ) : (
      <span>📎 Uploading file…</span>
    )}
    <button
      onClick={() => setLocalPreviews(prev => prev.filter(p => p.id !== preview.id))}
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        background: 'red',
        color: 'white',
        border: 'none',
        borderRadius: '50%',
        cursor: 'pointer',
      }}
    >
      ✖️
    </button>
  </div>
))
)}


   <div
  className={`messages-area ${selectedFiles.length > 0 ? 'with-preview' : ''}`}
  ref={messagesContainerRef}
>
  {messages.map((msg, index) => {
    const isSentByCurrentUser = msg.senderId === activeUser?.uid;
    const msgDate = msg.createdAt?.toDate?.() || new Date(msg.createdAt?.seconds * 1000);
    const prevMsg = messages[index - 1];
    const prevDate = prevMsg?.createdAt
      ? prevMsg.createdAt?.toDate?.() || new Date(prevMsg.createdAt.seconds * 1000)
      : null;

    const isNewDay = !prevDate || msgDate.toDateString() !== prevDate.toDateString();

    return (
      <React.Fragment key={msg.id}>
        {isNewDay && (
          <div
            style={{
              textAlign: 'center',
              fontSize: '0.8rem',
              color: '#999',
              margin: '12px 0',
            }}
          >
            {msgDate.toLocaleDateString()}
          </div>
        )}

        <div
          className={`group-chat-message ${isSentByCurrentUser ? 'group-sent' : 'group-received'}`}
          style={{ alignSelf: isSentByCurrentUser ? 'flex-end' : 'flex-start' }}
        >
          <div className="sender-name">
            {msg.senderName} {msg.agency && `(${msg.agency})`}:
          </div>
         {editingMsgId === msg.id ? (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
    
    {/* TEXT EDITOR */}
    <textarea
      value={editedMsg}
      onChange={(e) => setEditedMsg(e.target.value)}
      onBlur={() => handleSaveEdit(msg.id)}
      onKeyDown={(e) => e.key === 'Enter' && handleSaveEdit(msg.id)}
      autoFocus
      className={`edit-bubble ${isSentByCurrentUser ? 'sent' : 'received'}`}
      style={{ zIndex: 10 }}
    />

    {/* ATTACHMENT PREVIEW IN EDIT MODE */}
    {msg.mediaAttachments && msg.mediaAttachments.length > 0 && (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
        {msg.mediaAttachments.map((att, idx) => (
          <div key={idx} style={{ position: "relative", display: "inline-block" }}>

            {/* IMAGE PREVIEW */}
            {att.type === "image" ? (
              <img
                src={att.url}
                alt="attachment"
                style={{
                  width: "60px",
                  height: "60px",
                  objectFit: "cover",
                  borderRadius: "6px",
                  opacity: 0.9
                }}
              />
            ) : (
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  background: "#ececec",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px",
                  padding: "4px",
                  textAlign: "center"
                }}
              >
                📎 File
              </div>
            )}

            {/* DELETE BUTTON — INSTANT FIRESTORE UPDATE */}
            <button
              onMouseDown={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
              onClick={async (e) => {
                e.stopPropagation();
                const newMedia = msg.mediaAttachments.filter((_, i) => i !== idx);

                await updateDoc(
                  doc(db, "conversations", groupId, "messages", msg.id),
                  { mediaAttachments: newMedia }
                );
              }}
              style={{
                position: "absolute",
                top: "-6px",
                right: "-6px",
                background: "rgba(255,0,0,0.9)",
                border: "none",
                color: "white",
                borderRadius: "50%",
                width: "20px",
                height: "20px",
                cursor: "pointer",
                fontSize: "13px",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 0 4px rgba(0,0,0,0.4)"
              }}
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    )}

    {/* DELETE MESSAGE BUTTON */}
    <button
      onClick={(e) => {
        e.stopPropagation();
        handleDeleteMessage(msg.id);
      }}
      style={{
        marginTop: "4px",
        color: "red",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        alignSelf: "flex-end",
        fontSize: "0.9em"
      }}
    >
      🗑️ Delete
    </button>

  </div>
) : (
         <div className="group-message-content" style={{ marginTop: '2px', textAlign: 'left' }}>

{/* Show text if available */}
{msg.content && (
  <>
    <span>{msg.content}</span>

    {isSentByCurrentUser && (
      <span
        onClick={() => {
          setEditingMsgId(msg.id);
          setEditedMsg(msg.content);
        }}
        style={{ marginLeft: '8px', cursor: 'pointer', color: '#888' }}
      >
        ✏️
      </span>
    )}
  </>
)}

{/* Always show delete for your own messages */}
{isSentByCurrentUser && (
  <span
    onClick={() => handleDeleteMessage(msg.id)}
    style={{ marginLeft: '8px', cursor: 'pointer', color: 'red' }}
  >
    🗑️
  </span>
)}


  {msg.mediaAttachments && msg.mediaAttachments.length > 0 && (
  <div className="attachments" style={{ marginTop: '8px' }}>
    {msg.mediaAttachments.map((att, idx) => {
      if (att.type === 'image') {
        return (
          <div
            key={idx}
            style={{
              marginTop: '8px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            {/* Full-size modal trigger */}
            <img
              src={att.url}
              alt="uploaded"
              style={{
                maxWidth: '150px',
                maxHeight: '150px',
                borderRadius: '6px',
                cursor: 'pointer',
              }}
              onClick={() => setModalImage(att.url)}
            />
          </div>
        );
      } else {
        return (
          <div key={idx} style={{ marginTop: '8px' }}>
            <a
              href={att.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: '0.8rem',
                color: '#007bff',
                textDecoration: 'underline',
              }}
            >
              📎 Open Attachment
            </a>
          </div>
        );
      }
    })}
  </div>
)}

{modalImage && (
  <div className="group-image-modal">
    <ZoomableImage src={modalImage} alt="Full Size" />
    <div className="group-image-modal-buttons">
      <button onClick={saveHandler}>⬇️ Save Image</button>
      <button onClick={() => setModalImage(null)}>← Back</button>
    </div>
  </div>
)}

</div>
        )}

       <div className="group-message-footer">
  {isSentByCurrentUser && editingMsgId !== msg.id && (
    <div className="group-message-actions">
      <button
        type="button"
        onClick={() => {
          setEditingMsgId(msg.id);
          setEditedMsg(msg.content || '');
        }}
        aria-label="Edit message"
        title="Edit message"
      >
        ✏️
      </button>
      <button
        type="button"
        onClick={() => handleDeleteMessage(msg.id)}
        aria-label="Delete message"
        title="Delete message"
      >
        🗑️
      </button>
    </div>
  )}

  {(msg.createdAt || msg.editedAt) && (
    <div className="timestamp">
      {msg.editedAt?.toDate
        ? `Edited: ${msg.editedAt.toDate().toLocaleString([], {
            month: 'numeric',
            day: 'numeric',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })}`
        : msg.editedAt
        ? `Edited: ${new Date(msg.editedAt).toLocaleString([], {
            month: 'numeric',
            day: 'numeric',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })}`
        : new Date(msg.createdAt.seconds * 1000).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
          })}
    </div>
  )}
</div>

      </div>
     </React.Fragment>
    );
  })}
  <div ref={chatEndRef} />
</div>


	{selectedFiles.length > 0 && (
  <div className="file-preview-list">
    {selectedFiles.map((file, index) => (
      <div
        key={index}
        style={{
          display: 'flex',
          alignItems: 'center',
          
          gap: '8px',
        }}
      >
        {file.type.startsWith('image/') ? (
          <img
            src={URL.createObjectURL(file)}
            alt="preview"
            style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px' }}
          />
        ) : (
          <span>📄 {file.name}</span>
        )}
        <button
          onClick={() => handleRemoveFile(index)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1rem',
          }}
        >
          ❌
        </button>
      </div>
    ))}
  </div>
)}




 <div className="group-message-input-area">
  <div className="group-attachment-picker">
    <button
      type="button"
      className="group-upload-button"
      title="Add attachment"
      aria-label="Add attachment"
      aria-expanded={attachmentMenuOpen}
      onClick={() => setAttachmentMenuOpen(prev => !prev)}
    >
      +
    </button>
    {attachmentMenuOpen && (
      <div className="group-attachment-menu">
        <label className="group-attachment-menu-item">
          Gallery
          <input
            type="file"
            multiple
            style={{ display: 'none' }}
            ref={fileInputRef}
            onChange={handleFileUpload}
          />
        </label>
        <label className="group-attachment-menu-item">
          Camera
          <input
            type="file"
            accept="image/*"
            capture="environment"
            style={{ display: 'none' }}
            ref={cameraInputRef}
            onChange={handleFileUpload}
          />
        </label>
      </div>
    )}
  </div>

  <textarea
    placeholder="Type a message..."
    value={messageInput}
    onChange={(e) => {
      setMessageInput(e.target.value);

      // ✅ auto-resize
      e.target.style.height = "auto";
      e.target.style.height = Math.min(e.target.scrollHeight, 96) + "px";
    }}
    rows={1}
  />

  <button
    onClick={handleSendMessage}
    className="group-send-button"
    disabled={isSendingMessage || conversationDeleting}
  >
    {isSendingMessage ? 'Sending...' : 'Send'}
  </button>
</div>




	{showAddModal && (
  <div className="group-modal-overlay" onClick={() => setShowAddModal(false)}>
    <div className="search-group-modal-content" onClick={(e) => e.stopPropagation()}>

      {/* Search Fields */}
      <div className="search-field-row">
        <label>
          State:&nbsp;
          <select
            value={searchState}
            onChange={(e) => {
              setSearchStateTouched(true);
              setSearchState(e.target.value);
            }}
          >
            {getStatesWithHomeFirst(activeUser?.state).map((stateName) => (
              <option key={stateName} value={stateName}>{stateName}</option>
            ))}
          </select>
        </label>
      </div>

      <div className="search-field-row">
        <label>
          Search by:
          <select
            onChange={(e) => handleAddSearchField(e.target.value)}
            value=""
            style={{ marginLeft: '8px' }}
          >
            <option value="">Select filters</option>
            <option value="agency">Agency</option>
            <option value="assignment">Assignment</option>
            <option value="rank">Rank</option>
            <option value="lastName">Last Name</option>
          </select>
        </label>
      </div>

      {Object.entries(searchFields).map(([field, value]) => (
        <div key={field} className="search-field-row">
          <label>
            {field.replace(/([A-Z])/g, ' $1')}:&nbsp;

            {field === 'agency' && (
              <select
                value={value}
                onChange={(e) =>
                  setSearchFields((prev) => ({ ...prev, [field]: e.target.value }))
                }
              >
                <option value="">Select agency</option>
                {agencyList.map((agency) => (
                  <option key={agency} value={agency}>{agency}</option>
                ))}
              </select>
            )}

            {field === 'assignment' && (
              <select
                value={value}
                onChange={(e) =>
                  setSearchFields((prev) => ({ ...prev, [field]: e.target.value }))
                }
              >
                <option value="">Select assignment</option>
                {assignmentList.map((assignment) => (
                  <option key={assignment} value={assignment}>{assignment}</option>
                ))}
              </select>
            )}

            {field === 'rank' && (
              <select
                value={value}
                onChange={(e) =>
                  setSearchFields((prev) => ({ ...prev, [field]: e.target.value }))
                }
              >
                <option value="">Select rank</option>
                {rankList.map((rank) => (
                  <option key={rank} value={rank}>{rank}</option>
                ))}
              </select>
            )}

            {field === 'lastName' && (
              <input
                type="text"
                value={value}
                onChange={(e) =>
                  setSearchFields((prev) => ({ ...prev, [field]: e.target.value }))
                }
                placeholder="Enter last name"
              />
            )}

            <button
              onClick={() => handleRemoveSearchField(field)}
              style={{
                marginLeft: '6px',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1.2rem'
              }}
              title="Remove filter"
            >
              ❌
            </button>
          </label>
        </div>
      ))}

      {/* Search & Close Buttons */}
      <div className="search-modal-buttons">
        <button onClick={handleRunSearch}>Search</button>
        <button
  onClick={() => {
    setShowAddModal(false);
    setSearchResults([]);
    setSearchFields({});
    setSelectedUserIds([]);
    setSearchAttempted(false);
  }}
>
  Close
</button>

      </div>

 {/* SEARCH RESULTS */}
      <div className="search-results" style={{ maxHeight: '300px', overflowY: 'auto', marginTop: '10px' }}>
{searchResults.length > 0 && (
  <div style={{ marginBottom: '8px' }}>
    <label style={{ fontSize: '0.9rem' }}>
      <input
        type="checkbox"
        checked={searchResults.every(user => selectedUserIds.includes(user.id))}
        onChange={(e) => {
          if (e.target.checked) {
            const allIds = searchResults.map(user => user.id);
            setSelectedUserIds(allIds);
          } else {
            setSelectedUserIds([]);
          }
        }}
      /> Select All
    </label>
  </div>
)}

        {searchResults.length > 0 ? (
          searchResults.map((user) => {
            const name = user.fullName || `${user.firstName?.[0] || '?'}${user.lastName ? '.' + user.lastName : ''}`;
            return (
              <label key={user.id} className="select-user-item" style={{ display: 'block', margin: '4px 0' }}>
                <input
                  type="checkbox"
                  checked={selectedUserIds.includes(user.id)}
                  onChange={() => toggleUserSelection(user.id)}
                />
                {`${user.rank || ''} ${name}, ${user.assignment || ''}, ${user.agency || ''}`}
              </label>
            );
          })
     ) : (
  searchAttempted ? (
    <p style={{ color: '#888' }}>No available users found.</p>
  ) : null
)}

      </div>
	{selectedUserIds.length > 0 && (
  <div style={{ marginTop: '12px', textAlign: 'center' }}>
    <button
      onClick={handleAddSelectedUsers}
      style={{
        padding: '8px 16px',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: 'bold'
      }}
    >
      ➕ Add {selectedUserIds.length} to Group
    </button>
  </div>
)}


</div>
</div>
)}
</div>
);
}

export default GroupChat;
